import { ListingParameters, ListingResponseDTO } from "./dto/shared"

const DEFAULT_PAGE_SIZE = 500

const MAX_PAGES = 1000

export async function fetchAllPages<T>(
	fetchPage: (params: ListingParameters) => Promise<ListingResponseDTO<T>>,
	pageSize: number = DEFAULT_PAGE_SIZE,
): Promise<T[]> {
	const items: T[] = []
	let anchor: string | undefined

	for (let page = 0; page < MAX_PAGES; page++) {
		const response = await fetchPage({ size: pageSize, anchor })
		items.push(...response.data)

		if (!response.hasMore || !response.anchor || response.anchor === anchor) {
			break
		}
		anchor = response.anchor
	}

	return items
}
